import * as _ from 'lodash';
import moment from 'moment';
moment.locale("ru")

export const getCurrentYear = yearsList => {
  return _.find(yearsList, y => (
    moment().isBetween(moment(y.begdate, 'DD.MM.YYYY').format('YYYY/MM/DD'), moment(y.enddate, 'DD.MM.YYYY').format('YYYY/MM/DD'), null, '[]')
)) || yearsList[yearsList.length-1]
}

export const getCurrentTerm = termsList =>
  _.find(termsList, t => (
    moment().isBetween(moment(t.term_begin, 'DD.MM.YYYY'), moment(t.term_end, 'DD.MM.YYYY'), null, '[]')
  )) || termsList[termsList.length-1]

export const getYearByCourse = (nowCourse, currentCourse, yearsList) => {
  const diff = nowCourse-currentCourse
  const currentYear = getCurrentYear(yearsList)
  const ind = yearsList.map(it => it.xp_key).indexOf(currentYear.xp_key)
  return diff>=0 ? yearsList[ind-(diff)] : yearsList[ind]
}
